import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppStateContextType {
  currentRightPaneUrl: string | null;
  setCurrentRightPaneUrl: (url: string | null) => void;
}

const AppStateContext = createContext<AppStateContextType | undefined>(undefined);

export const AppStateProvider = ({ children }: { children: ReactNode }) => {
  const [currentRightPaneUrl, setCurrentRightPaneUrl] = useState<string | null>("/default");

  const handleSetCurrentRightPaneUrl = (url: string | null) => {
    console.log("🔄 AppStateContext: Setting currentRightPaneUrl from", currentRightPaneUrl, "to", url);
    setCurrentRightPaneUrl(url);
  };

  return (
    <AppStateContext.Provider 
      value={{ 
        currentRightPaneUrl, 
        setCurrentRightPaneUrl: handleSetCurrentRightPaneUrl 
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppState = () => {
  const context = useContext(AppStateContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within an AppStateProvider');
  }
  return context;
};
